export default __webpack_public_path__ + "static/media/emptyData.7f61adb8.svg";